<template>
    <template
        v-for="(item) in modulesWithComponent"
        :key="item.id"
    >
        <KeepAlive>
            <component
                :is="item.component"
                v-if="item.component"
                :config="item.config"
                :data-cy="`module-component-${item.config.component}`"
                :filter="nestedFilter ? filter : null"
                :search-term="searchTerm"
                :search-properties="searchProperties"
                :is-remote-search="isRemoteSearch"
            />
        </KeepAlive>
    </template>
    <template v-if="isEmpty">
        <slot name="empty" />
    </template>
</template>

<script setup>
    import components from '@/constants/components'

    const emit = defineEmits(['appendModules'])

    const props = defineProps({
        modules: Array,
        filter: Function,
        nestedFilter: Boolean,
        paginationUrl: String,
        searchTerm: String,
        searchProperties: Array,
        isRemoteSearch: Boolean,
    })

    const modulesWithComponent = computed(() => {
        return props.modules.map((module) => ({
            id: module.uuid,
            component: components[module.component],
            config: module,
        }))
    })

    const isEmpty = computed(() => {
        return modulesWithComponent.value.length === 0
    })

</script>
